import audioFiles from "../../assets/audio/audioFiles"

const BuzzerAudio = () => {
  return (
    <audio id="audio" loop autoPlay>
      <source src={audioFiles.siren} type="audio/wav" />
    </audio>
  )
}
export default BuzzerAudio;